<template>
    <el-row :gutter="30"  class="mw-100 manage-footer-logo" >
        
        <el-col :lg="24" :xs="24">
            <el-card>
                <el-form 
                    class="text-center font-24" 
                    ref="addLogoRef"
                    :model="currentLogoData"
                    :rules="currentLogoDataRules"
                    label-position="top"
                >
                    <el-row :gutter="30">
                        <el-col :lg="24" :xs="24">
                            <el-form-item>
                                <el-button type="primary" @click="manageLogo('addLogoRef')" class="text-cap">
                                    <font-awesome-icon :icon="['fas', 'floppy-disk']" style="width:20px" class="mr-10" />
                                    save
                                </el-button>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="12" :xs="24">
                            <el-form-item  label="Footer Logo" prop="imageBase64">
                                <el-image 
                                    style="width: 150px; height: 150px;margin-right:20px" 
                                    :src="isAddLogo ? currentLogoData.imageURL :  $getImage(currentLogoData.imageURL) || ''" 
                                    fit="cover"
                                    :zoom-rate="1.2"
                                    :preview-src-list="[isAddLogo ? currentLogoData.imageURL : $getImage(currentLogoData.imageURL)]"
                                    :preview-teleported="true"
                                >
                                    <template #error>
                                        <div class="image-slot">
                                            <font-awesome-icon :icon="['fas', 'image']" />
                                        </div>
                                    </template>
                                </el-image>
                                <el-upload
                                    ref="imageBase64"
                                    action="#"
                                    :auto-upload="false"
                                    :on-change="onUploadImage"
                                    :disabled="fileUploaded"
                                    :on-remove="handleRemoveImage"
                                    accept="image/png, image/jpeg,image/gif"
                                    class="font-24 d-flex align-center flex-1"
                                >
                                    <font-awesome-icon :icon="['fas', 'upload']" style="width:20px" class="mr-10" />
                                </el-upload>
                            </el-form-item>
                        </el-col>
                        
                        
                    </el-row>
                </el-form>
            </el-card>
        </el-col>
    </el-row>
   
    
</template>

<script>
export default {
    data(){
        return {
           
            fileList:[],
            isAddLogo:true,
            fileUploaded:false,
            currentLogoData:{},
            currentLogoDataRules:{
                imageBase64:{
                    required:true,
                    trigger:'blur',
                    message:'required field'
                }
            }
        };
    },
    computed:{
        cachedLogo(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.settings?.logos?.currentLogo || {}
        }
    },
    mounted(){
        if (this.$route.params.id && this.$route.params.id == this.cachedLogo.id) {
            this.isAddLogo = false;
            this.currentLogoData = JSON.parse(JSON.stringify(this.cachedLogo));
            this.currentLogoData = this.converUpdatedObj(this.currentLogoData);
            
           
        }else{
            this.$router.push({
                name:'logos-list',
            })
        }
    },
    
    methods:{
        initState(){
            return {
             
                translates:this.$setTranslateKeys({
                    'description':'',
                    'title':'',
                }),
               
            }
        },
       
        async manageLogo(formName){
            const element = this.$refs[formName];
            element.validate(async (valid) => {
                if (!valid) {
                    this.$message({
                        message:`the image required if you want to update it `,
                        type:'info',
                        duration:5000,
                        showClose: true,
                    });
                }
            }).then(data =>{
                if (data){
                    this.manageLogoAfterValidate()
                }
            })  
           
            
            
            
            
            
        },
        async manageLogoAfterValidate(){
            let clonedData = JSON.parse(JSON.stringify(this.currentLogoData));
            delete clonedData.imageURL;
            
            
            const response = await this.$store.dispatch(this.isAddLogo ? 'addLogo':'editLogo',clonedData);
            if (response.data.status == 1) {
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
                await this.$store.dispatch('getAllLogos');
                this.$router.push({
                    name:'logos-list'
                })
            }
        },
        onUploadImage(file){
            const FR = new FileReader();
            let module = this;
            FR.addEventListener("load", function(evt) {
                module.currentLogoData.imageBase64 = evt.target.result;
            }); 
            this.currentLogoData.imageURL =  URL.createObjectURL(file.raw);

            FR.readAsDataURL(file.raw);
        }, 
        handleRemoveImage(){
            this.currentLogoData.imageURL = this.isAddLogo ? '' : this.cachedLogo.imageURL
        },   
      
        
        converUpdatedObj(oldObj){
            // Copy the object
            let newObj = Object.assign({}, oldObj);
            delete newObj.value;
            delete newObj.image2URL;
            return newObj
        }
    }
}
</script>
<style lang="scss">
    .manage-footer-logo {
        .ck-editor {
            width:100%;
        }
    }
</style>